import { useEffect } from "react";
import {
  formatCurrency,
  formatNumber,
  getSinglarOrPluralWord,
} from "../../../utilities/helpers";

import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import Stack from "react-bootstrap/Stack";

import { EditButton } from "../../EditButton";
import { TrashButton } from "./../../TrashButton";

import discount from "../../../assets/icons/discount.svg";

export default function PromoCode({
  promoCode,
  priceOpts,
  applyToOpts,
  limitOpts,
  handleIsActive,
  openAddPromoCode,
  confirmRemoval,
}) {
  useEffect(() => {
    if (Number(promoCode?.max_redemptions)) {
      // if promo code is active and has reached its redemption limit, switch its active property to false
      if (promoCode?.isActive && hasReachedLimit(promoCode)) {
        handleIsActive(undefined, promoCode?.id, false);
      }
    }
  }, [promoCode]);

  // redemptions are greater or equal to code used, disable active toggle and switch active property to false
  const hasReachedLimit = (promoCode) => {
    return Number(promoCode?.max_redemptions)
      ? Number(promoCode?.max_redemptions) === Number(promoCode?.codeUsed)
      : false;
  };
  return (
    <Stack
      direction="horizontal"
      gap={4}
      as="li"
      className="promo-code list-item list-item-lg list-item--light list-item--with-border"
    >
      <InputGroup className="w-25">
        <InputGroup.Text id="code-val">
          <img src={discount} alt="" />
        </InputGroup.Text>
        <Form.Control
          id="code-val"
          name="code"
          aria-describedby="code-val"
          value={promoCode?.code || ""}
          disabled
        />
      </InputGroup>
      <Stack gap={2} className="col justify-content-center vertical-seperator">
        <span className="label">
          {
            priceOpts.find((opt) => opt?.value === promoCode?.priceOption)
              ?.label
          }
        </span>
        {promoCode?.priceOption === priceOpts[1]?.value ? (
          <span className="value">{promoCode?.percent_off}%</span>
        ) : (
          <span className="value">{formatCurrency(promoCode?.amount)}</span>
        )}
      </Stack>
      <Stack gap={2} className="col justify-content-center vertical-seperator">
        <span className="label">Discount to</span>
        <span className="value">
          {applyToOpts.find((opt) => opt.value === promoCode?.appliedTo)?.label}
        </span>
      </Stack>
      <Stack gap={2} className="col justify-content-center vertical-seperator">
        <span className="label">Limit</span>
        <span className="value">
          {promoCode?.max_redemptions
            ? formatNumber(promoCode?.max_redemptions)
            : limitOpts[0]?.label}
        </span>
      </Stack>
      <Stack gap={2} className="col justify-content-center vertical-seperator">
        <span className="label">Code used</span>
        <span className="value">
          {formatNumber(promoCode?.codeUsed)}{" "}
          {getSinglarOrPluralWord(promoCode?.codeUsed, "time")}
        </span>
      </Stack>
      <Stack gap={2} className="col justify-content-center">
        <span className="label">Events</span>
        <span className="value">{formatNumber(promoCode?.events?.length)}</span>
      </Stack>
      <Stack gap={2} className="col justify-content-center vertical-seperator">
        <Form.Check
          type="switch"
          id={promoCode?.id}
          label="Active"
          checked={promoCode?.isActive}
          onChange={(e) => handleIsActive(e, promoCode?.id, e.target.checked)}
          disabled={hasReachedLimit(promoCode)}
        />
      </Stack>
      <Stack direction="horizontal" gap={4} className="btn-col">
        {/* <EditButton onClick={(e) => openAddPromoCode(e, promoCode?.id)} /> */}
        <TrashButton
          variant="danger"
          id={promoCode?.id}
          onClick={confirmRemoval}
          isDisabled={promoCode?.codeUsed >= 1}
        />
      </Stack>
    </Stack>
  );
}
